export enum ProductRouteName {
    Index = 'sales.products.index',
    Create = 'sales.products.create',
    Edit = 'sales.products.edit',
    Clone = 'sales.products.clone',
    Details = 'sales.products.details',
}

export default {
    path: 'products',
    name: ProductRouteName.Index,
    component: () => import('@/views/sales/product/Index.vue'),
    meta: {
        label: 'Products',
        auth: true,
        permission: 'manage-products',
        icon: 'fal fa-box-full fa-fw',
        location: 'sidebar',
        parent: 'sales',
    },
    children: [
        {
            path: 'create',
            name: ProductRouteName.Create,
            component: () => import('@/views/sales/product/Index.vue'),
            meta: {
                auth: true,
                label: 'Create Product',
                permission: 'manage-products',
                icon: 'fal fa-tags fa-fw',
                location: 'sidebar',
                parent: 'sales.products.index',
            },
        },
        {
            path: ':productUuid/edit',
            name: ProductRouteName.Edit,
            component: () => import('@/views/sales/product/Index.vue'),
            meta: {
                label: 'Edit Product',
                auth: true,
                permission: 'manage-products',
                icon: 'fal fa-tags fa-fw',
                location: 'sidebar',
                parent: 'sales.products.index',
            },
        },
    ],
}
